import React, { useRef } from 'react';
import { ExternalLink } from 'lucide-react';
import './ViewerComponents.css';

interface UrlViewerProps {
  contentUrl: string;
  title: string;
}

export const UrlViewer: React.FC<UrlViewerProps> = ({ contentUrl, title }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  return (
    <div className="content-viewer content-viewer--url">
      <div className="content-viewer__header">
        <div className="content-viewer__header-left">
          <ExternalLink size={20} className="content-viewer__icon" />
          <span className="content-viewer__title">External Content</span>
        </div>
        <a
          href={contentUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="content-viewer__btn content-viewer__btn--primary"
        >
          <ExternalLink size={18} />
          Open in New Tab
        </a>
      </div>
      <div className="content-viewer__body">
        <iframe
          ref={iframeRef}
          src={contentUrl}
          className="content-viewer__iframe"
          title={title}
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
        />
      </div>
    </div>
  );
};
